import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureaddCountry, successaddCountry } from "./AddCountrySlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { ICountry } from "../../../Pages/Country/ICountry";

import {
  failuredeleteCountry,
  successdeleteCountry,
} from "./DeleteCountrySlice";
import { failurelistCountry, successlistCountry } from "./ListCountrySlice";
import { failureEditCountry, successEditCountry } from "./EditCountrySlice";

// list
const ListCountryApi = () => {
  return api.get("/api/category/regions");
};

export function* ListCountryCall() {
  try {
    const response: AxiosResponse = yield call(ListCountryApi);
    yield put(successlistCountry(response.data));
  } catch (error) {
    yield put(failurelistCountry(error));
  }
}

// add
const AddCountryApi = (action: PayloadAction<ICountry>) => {
  return api.post("/api/category/add-region", action.payload);
};

export function* AddCountryCall(action: PayloadAction<ICountry>) {
  try {
    const response: AxiosResponse = yield call(AddCountryApi, action);
    yield put(successaddCountry(response.data));
  } catch (error) {
    yield put(failureaddCountry(error));
  }
}

// edit
const EditCountryApi = (action: PayloadAction<ICountry>) => {
  return api.put("/api/category/update-region", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditCountryCall(action: PayloadAction<ICountry>) {
  try {
    const response: AxiosResponse = yield call(EditCountryApi, action);
    yield put(successEditCountry(response.data));
  } catch (error) {
    yield put(failureEditCountry(error));
  }
}

// delete
const DeleteCountryApi = (action: PayloadAction<number>) => {
  return api.delete("/api/category/delete-region", {
    params: { id: action.payload },
  });
};

export function* DeleteCountryCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteCountryApi, action);
    yield put(successdeleteCountry(response.data));
  } catch (error) {
    yield put(failuredeleteCountry(error));
  }
}
